import withDynamicDestroyOnUnmount from './WithDynamicDestroyOnUnmount';

export default withDynamicDestroyOnUnmount;
